import { getFont, getMargins } from '@24i/nxg-sdk-higgs';
import { Theme } from '@24i/nxg-sdk-photon';
import { isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';

import { GenreScreenStylesTypes } from './types';

const GenreScreenStyles = (theme: Theme): GenreScreenStylesTypes => ({
    holder: {
        backgroundColor: theme.color.background1,
        flex: 1,
        flexDirection: 'column',
    },
    sectionsContainer: { flex: 1, flexDirection: 'column', overflow: 'hidden' },
    pickerHolder: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: theme.color.background1,
        ...getMargins(),
        marginTop: 96,
        ...(isWebMobile() && {
            marginTop: 20,
        }),
    },
    animatedPickerHolderBackground: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: theme.color.primaryBlur1Fallback,
        borderBottomWidth: 1,
        borderBottomColor: theme.color.contrast4,
    },
    pickerItem: {
        textAlign: 'center',
        color: theme.color.textPrimary,
        fontSize: 20,
        lineHeight: 50,
        height: 50,
        fontWeight: '700',
    },
    sectionTitle: {
        textAlign: isWebMobile() ? 'center' : 'left',
        ...getFont(theme, 'h2'),
        color: theme?.color?.textPrimary,
        width: '100%', // Ensure full width
        justifyContent: isWebMobile() ? 'center' : 'flex-start', // Center horizontally on mobile, left on desktop
        alignSelf: isWebMobile() ? 'center' : 'flex-start', // Center self on mobile, left on desktop
    },
    fetchingActivityIndicator: {
        paddingTop: 20,
        width: '89%',
    },
    activityIndicator: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    gridContainer: {
        flex: 1,
        ...getMargins(),
    },
});

export default GenreScreenStyles;
